import React from 'react';
import classNames from "classnames";
import styles from './XArticleSticker.module.scss';
import { ETheme } from '../../types/enums/ETheme';

export interface IArticleStickerProps {
    children? : React.ReactNode;
    theme?: ETheme;
    onClick?: (owner: XArticleSticker) => void;
}

export interface IArticleStickerState {
    theme: ETheme;
}

export class XArticleSticker extends React.Component<IArticleStickerProps, IArticleStickerState> {
    static defaultProps = {
        theme: ETheme.Blue
    }
    public constructor(props: IArticleStickerProps) {
        super(props);
        this.state = {
            theme: this.props.theme === undefined
                ? ETheme.Red
                : this.props.theme
        };
        this.onClick = this.onClick.bind(this);
    }
    
    componentDidMount(): void{
    }
    componentWillUnmount(): void{
    }
    onClick(): void {this.props.onClick?.(this);};
    render(): React.ReactNode {
        return (
            <div className={classNames(styles.XArticleSticker)} data-theme={this.state.theme} onClick={this.onClick}>
                {this.props.children}
            </div>
        );
    }
}
